export const BANNER_PRIORITY = {
  EMPTY_STATE: 0,
  ZOOM_ONBOARDING: 10,
  FINANCIAL_PLANNING_ONBOARDING: 10,
  EMAIL_ONBOARDING: 20,
  MCP_PROMO: 100,
} as const
